import { ContentStat } from "seneca-common/features/stats/state";
import { chooseMFromN } from "seneca-common/utils/functions";

import { GenerateContentOptions } from "../../types";
import { copyWords } from "../../wordfill/logic/content";
import { TestableWord } from "../../wordfill/types";
import { Content, ContentSource } from "../types";

export function generateContent(
  source: ContentSource,
  { testingActive, maxDifficulty }: GenerateContentOptions,
  contentStat?: ContentStat
): Content {
  const steps = source.steps.map(step => {
    const equationWords = copyWords(step.equation);
    const testableWords = equationWords.filter(
      word => typeof word !== "string"
    ) as TestableWord[];
    const testableWordCount = testableWords.length;
    const numberToTest = getNumberOfWordsToTest(
      contentStat,
      testableWordCount,
      maxDifficulty
    );
    const testedIndexes = chooseMFromN(numberToTest, testableWordCount);

    testedIndexes.forEach(index => (testableWords[index].testing = true));
    return { ...step, equation: equationWords };
  });
  return { ...source, steps };
}

const getNumberOfWordsToTest = (
  meta: ContentStat | null | undefined,
  testableWordCount: number,
  maxDifficulty: boolean | null | undefined
) => {
  if (maxDifficulty) return testableWordCount;
  let maxNTested = 0;
  if (!meta || meta.timesStudied < 2) maxNTested = 1;
  else if (meta.timesStudied < 5) maxNTested = 2;
  else maxNTested = 3;
  return Math.min(maxNTested, testableWordCount);
};
